
export const FEATURES = {
  PDF_RENDERER: 'FEATURE_PDF_RENDERER',
  EDITABLE_TE: 'FEATURE_EDITABLE_TE',
  EDITABLE_TABLE: 'FEATURE_EDITABLE_TABLE',
  SMIED_ACCESS: 'FEATURE_SMIED_ACCESS',
  EISM_SECTION: 'FEATURE_EISM_SECTION',
};

/**
 * feature toggle
 */
export const getFeatureToggleList = () => {
  const { REACT_APP_STAGE } = process.env;
  const releaseToggles = {
    dev: {
      [FEATURES.EDITABLE_TE]: true,
      [FEATURES.EDITABLE_TABLE]: true,
      [FEATURES.SMIED_ACCESS]: true,
      [FEATURES.EISM_SECTION]: true,
    },
    int: {
      [FEATURES.EDITABLE_TE]: true,
      [FEATURES.EDITABLE_TABLE]: true,
      [FEATURES.SMIED_ACCESS]: true,
      [FEATURES.EISM_SECTION]: true,
    },
    val: {
      [FEATURES.EDITABLE_TE]: true,
      [FEATURES.EDITABLE_TABLE]: true,
      [FEATURES.SMIED_ACCESS]: true,
      [FEATURES.EISM_SECTION]: true,
    },
    pro: {
      [FEATURES.EDITABLE_TE]: true,
      [FEATURES.EDITABLE_TABLE]: true,
      [FEATURES.SMIED_ACCESS]: true,
      [FEATURES.EISM_SECTION]: false,
    }
  };
  return releaseToggles[REACT_APP_STAGE];
};
